/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {Row, Col, Box, Pagination} from 'adminlte-2-react';
import Loader from '../utils/Loader';
import {Alert} from '../ui/alert';
import {toTitleCase} from '../utils/utils';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {ButtonWithLoading} from '../utils/ButtonWithLoading';
import {Content} from '../ui/Content';
import {useWindowSize} from '../utils/useWindowSize';

export const ParametrosListView = ({
  history,
  topAlert,
  submitAlert,
  totalResults,
  page,
  pageSize,
  handlePage,
  lista,
  parametrosGet,
}) => {
  const {isMobile} = useWindowSize();

  return (
    <Content title="Parámetros" history={history}>
      {topAlert.text && (
        <Alert
          title={topAlert.title}
          type={topAlert.type}
          text={topAlert.text}
          closable={topAlert.closable}
        />
      )}

      <Row>
        <Col md="10" mdOffset="1">
          <Box title="Lista">
            <div style={{display: 'block'}}>
              <span>Total: {totalResults}</span>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                justifyContent: 'space-between',
              }}>
              <div>
                <Pagination
                  activePage={page - 1}
                  pageSize={pageSize}
                  totalElements={totalResults}
                  onChange={page => handlePage(page + 1)}
                  labels={{
                    first: 'Primera',
                    last: 'Última',
                    previous: 'Anterior',
                    next: 'Siguiente',
                  }}
                />
              </div>
            </div>

            <Loader isLoading={parametrosGet.loading}>
              {lista && lista.length > 0 ? (
                <Box noPadding={true} border={false} style={{borderTop: 0}}>
                  <div className="table-responsive">
                    <DataTable
                      lazy
                      pt={{
                        table: {
                          className: 'table table-hover',
                        },
                      }}
                      value={lista}
                      emptyMessage="No se encontraron registros">
                      <Column
                        header="Acciones"
                        body={parametro => (
                          <ButtonWithLoading
                            text="Editar"
                            size="sm"
                            type="default"
                            submit={() =>
                              history.push(`/parametro/editar/${parametro._id}`)
                            }
                          />
                        )}></Column>

                      <Column
                        field="nombre"
                        header="Nombre"
                        body={parametro => toTitleCase(parametro.concepto)}
                      />

                      <Column
                        field="periodo"
                        header="Periodo"
                        body={parametro => toTitleCase(parametro.periodo)}
                      />

                      <Column
                        field="cantidad"
                        header="Cantidad"
                        body={parametro => parametro.valor}
                      />
                    </DataTable>
                  </div>
                </Box>
              ) : (
                <h4>No se han encontrado registros</h4>
              )}
            </Loader>
            <Pagination
              activePage={page - 1}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={page => handlePage(page + 1)}
              labels={{
                first: 'Primera',
                last: 'Última',
                previous: 'Anterior',
                next: 'Siguiente',
              }}
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>

            {submitAlert.text && (
              <Alert
                title={submitAlert.title}
                type={submitAlert.type}
                text={submitAlert.text}
                closable={submitAlert.closable}
              />
            )}
          </Box>
        </Col>
      </Row>
    </Content>
  );
};
